import React, {Component} from 'react';
import faq1 from "../../../../../../assets/img/faq1.jpg";
import faq2 from "../../../../../../assets/img/faq2.jpg";
import faq3 from "../../../../../../assets/img/faq3.jpg";
import faq4 from "../../../../../../assets/img/faq4.jpg";
import faq5 from "../../../../../../assets/img/faq5.jpg";
import faq6 from "../../../../../../assets/img/faq6.png";
import faq7 from "../../../../../../assets/img/faq7.png";
import faq8 from "../../../../../../assets/img/faq8.png";
import {Link} from "react-router-dom";
import {FormattedMessage} from "react-intl";
import '../FaqPages/YourOrder.css'
import FocusPageId from "../../FocusPageId";
import InitialQuotationState from "../../../../QuotationForm/InitialQuotationState";
import Modal from "react-bootstrap/es/Modal";
import UserInquiryForm from "../../../../UserInquiryForm/UserInquiryForm";


let i = 0;

class YourOrder extends React.Component {
    componentDidMount() {
        // window.scrollTo(0, 0);
        let element = document.getElementById(FocusPageId.selectedId.elementId);
        element.scrollIntoView(true);
        element.classList.add('mystyle');
        // element.style.paddingTop="50px"
        window.scrollTo({
            top: document.getElementById(FocusPageId.selectedId.elementId).offsetTop - 40,
            behavior: 'smooth'
        });

    }

    constructor(props) {
        super(props);

        this.state = {
            show: false
        };

        this.positionAdject = this.positionAdject.bind()
        this.dataCreationPageId = this.dataCreationPageId.bind()
        this.handleShow = this.handleShow.bind()
        this.handleClose = this.handleClose.bind()
    };


    handleShow = () => {
        this.setState({show: true});
        InitialQuotationState.fromFlow = false;

    };
    handleClose = () => {

        this.setState({show: false});
        InitialQuotationState.fromFlow = true;

    };

    dataCreationPageId = () => {
        FocusPageId.selectedId.elementId = "a";
    }

    positionAdject = () => {
        i++;
        // if(i<3){
        //     document.getElementById(FocusPageId.selectedId.elementId).style.paddingTop="0px";

        // }

    };

    render() {

        return (
            <div className="static-pages" onWheel={() => this.positionAdject()}>
                <div className="background-div">
                    <li><h3 className="inline-block-element"><b>ご注文について</b></h3></li>
                     <div className="brElement"></div>
                    <h4 id="a"><b> 会員でなくても注文できますか？</b>
                    </h4>
                    <p className='all-content-font-size'> ご登録いただいた方のみ注文いただけます。
                    </p>
                    <p className='all-content-font-size'> 必要な情報をご登録いただいています、登録に際して費用は一切不要です。
                    </p>
                    <p className='all-content-font-size'> ※Googleアカウントをお持ちのお客様は、Googleアカウントを使ったログインが出来ます。
                    </p>
                     <div className="brElement"></div>
                    <h4 id="b"><b> 土曜日・日曜日・祝日も営業していますか？</b>
                    </h4>
                    <p className='all-content-font-size'>ガーバーファイルのアップロード・注文は24時間受付しておりますが、データチェックの通常時間は
                    </p>
                    <p className='all-content-font-size'> 平日の9：00 ～ 18：00（HKT/GMT+8）になります。
                    </p>
                    <p className='all-content-font-size'> ※現在の日本と香港との時差は、1時間です。日本の方が、1時間進んでいます。
                    </p>
                    <p className='all-content-font-size'> 但し、弊社の定める休業日を除きます。
                        {/*営業カレンダー*/}
                        <Link to="/calendar">
                            {/*<FormattedMessage id="app.beginner.signupbtn"*/}
                            {/*defaultMessage="Tap here to signup"*/}
                            {/*description=""*/}
                            {/*/>*/}
                            <text className="faq-colored-link">営業カレンダー</text>
                        </Link>
                    </p>

                     <div className="brElement"></div>
                    <h4 id="c"><b> サービス全体の流れがわかりません。</b>
                    </h4>
                    <p className='all-content-font-size'> 会員登録からお手元に届くまでの流れは下記の通りです。
                    </p>
                    <ol className='all-content-font-size'>
                        <li className='all-content-line-height'> 無料の会員登録をする
                        </li>
                        <li className='all-content-line-height'> オンライン見積りをする
                        </li>
                        <li className='all-content-line-height'> ガーバーファイルをアップロードする
                        </li>
                        <li className='all-content-line-height'> PayPalで入金をする
                        </li>
                        <li className='all-content-line-height'> オペレーターによるガーバーファイルチェックする
                        </li>
                        <li className='all-content-line-height'> ガーバーファイルが承認され注文確定
                        </li>
                        <li className='all-content-line-height'> 生産（生産中、進捗状況が確認できます）
                        </li>
                        <li className='all-content-line-height'> 香港集荷（検品・梱包・出荷）
                        </li>
                        <li className='all-content-line-height'> 配送、香港出荷日より1〜2日程度でお届け（日本向けドアツードアの国際宅急便サービスSGX便）
                        </li>
                    </ol>
                    <p className='all-content-font-size'> 詳細は
                        <Link to="/flow">
                            <text className="faq-colored-link"> こちら</text>
                        </Link>をご確認くださいませ。
                    </p>

                     <div className="brElement"></div>
                    <h4 id="d"><b> 電話での注文はできますか？</b>
                    </h4>
                    <p className='all-content-font-size'> 電話での注文は受け付けておりません。
                    </p>
                    <p className='all-content-font-size'> お手数ではございますが会員登録のうえ、当サイトよりご注文お願いいたします。
                    </p>

                     <div className="brElement"></div>
                    <h4 id="e"><b> スマートフォンでの注文はできますか？</b>
                    </h4>
                    <p className='all-content-font-size'> スマートフォンからのご注文も可能です。
                    </p>
                    <p className='all-content-font-size'> 各必須項目を選択、入力して頂ければ見積結果が自動算出されます。
                    </p>
                    <p className='all-content-font-size'> ガーバーデータをアップロードし、ご注文可能です。
                    </p>
                    <p className='all-content-font-size'> 但し、アップロード出来ない場合は、お手数ではございますがパソコンからご注文お願いいたします。
                    </p>

                     <div className="brElement"></div>
                    <h4 id="f"><b> 注文内容を確認したいのですが。</b>
                    </h4>
                    <p className='all-content-font-size'> ログイン完了後、アカウントページにて注文内容、進捗状況をご確認することができます。
                    </p>

                     <div className="brElement"></div>
                    <h4 id="g"><b> ガーバーデータ作成について教えて下さい。</b>
                    </h4>
                    <p className='all-content-font-size'>
                        {/*<Link to="/datacreationandUpload">*/}
                        {/*<text className="faq-colored-link">メニュー ガーバーデータ作成</text>*/}
                        {/*</Link>*/}
                        {/*についてをご参考下さい。*/}

                        <Link to="/datacreationandUpload" onClick={this.dataCreationPageId}>
                            <text className="faq-colored-link">ガーバーデータ作成</text>
                        </Link>
                        についてを参照下さい。

                    </p>

                     <div className="brElement"></div>
                    <h4 id="h"><b> プリント基板製造サービスで1000枚以上のご注文は可能ですか？</b>
                    </h4>
                    <p className='all-content-font-size'>

                        {/*<Link to="/inquiry">*/}
                        <text className="faq-colored-link" onClick={this.handleShow}> お問い合せフォームより</text>
                        {/*</Link>*/}
                        、詳細をご入力のうえ、お問合せください。
                    </p>
                     <div className="brElement"></div>
                    <h4 id="i"><b> 見積書発行はしてもらえますか？</b>
                    </h4>
                    <p className='all-content-font-size'> ログイン完了後、アカウントページにて注文明細が表示されますので、ブラウザによる印刷機能をご利用ください。
                    </p>
                    <p className='all-content-font-size'> 支払い完了後はアカウントページにて、確定された注文明細・請求書をダウンロードすることができます。
                    </p>
                    {/*<p className='all-content-font-size'>&nbsp;&nbsp;&nbsp;&nbsp;*/}
                        {/*<text className="red-faq-txt">下記画像はサイト完成後、差し替え必要</text>*/}
                    {/*</p>*/}
                    <img src={faq1} className=" faq-full-img"/>
                     <div className="brElement"></div>
                     <div className="brElement"></div>
                    <h4 id="j"><b>
                        注文番号はどこで確認できますか？
                    </b>
                    </h4>
                    <p className='all-content-font-size'>
                        ログイン完了後、アカウントページにて確認できます。
                    </p>
                    {/*<p className='all-content-font-size'>&nbsp;&nbsp;&nbsp;&nbsp;*/}
                        {/*<text className="red-faq-txt">下記画像はサイト完成後、差し替え必要</text>*/}
                    {/*</p>*/}
                    <img src={faq2} className=" faq-full-img"/>
                     <div className="brElement"></div>
                     <div className="brElement"></div>

                    <div style={{display : "none"}}>
                    <h4 id="k"><b> リピート注文はできますか？</b>
                    </h4>
                    <p className='all-content-font-size'> ログイン後、アカウントページにてリピート注文ができます。
                    </p>
                    <p className='all-content-font-size'> リピートボタンをクリック後、数量を選択し“送信”ボタンを押してください、リピート注文がカートに移動されますので
                    </p>
                    <p className='all-content-font-size'> お支払いを完了させてください。
                    </p>
                    {/*<p className='all-content-font-size'>&nbsp;&nbsp;&nbsp;&nbsp;*/}
                        {/*<text className="red-faq-txt">*/}
                            {/*下記画像はサイト完成後、差し替え必要*/}
                        {/*</text>*/}
                    {/*</p>*/}
                    </div>

                    <img src={faq3} className="faq-full-img order-report-img" />
                     <div className="brElement"></div>
                     <div className="brElement"></div>
                    <h4 id="l"><b>
                        複数の基板を注文したいのですが、方法を教えて下さい。</b>
                    </h4>
                    <p className='all-content-font-size'>
                        注文する基板に☑を入れて、ご購入手続きへを行って下さい。 <div className="brElement"></div>
                        ※複数の基板をご注文された場合、複数割引が適用されます。
                    </p>
                    {/*<p className='all-content-font-size'>&nbsp;&nbsp;&nbsp;&nbsp;*/}
                        {/*<text className="red-faq-txt"> 下記画像はサイト完成後、差し替え必要</text>*/}
                    {/*</p>*/}

                    <img src={faq4} className=" faq-full-img"/>
                     <div className="brElement"></div>
                    {/* <div className="brElement"></div>*/}
                    <h4 id="m"><b>
                        プリント基板をシート形状にて注文する方法を教えて下さい。</b>

                    </h4>
                    <p className='all-content-font-size'>ガーバーファイルは単品形状だが、注文時に1つの基板を多数個取りにし面付け形状することができます
                    </p>
                    <p className='all-content-font-size'> KITCUTで面付け希望：「はい」を選択して、シート形状にしたい（X）方向へ希望数量、（Y）方向へ希望数量を入力して下さい。
                    </p>
                    <p className='all-content-font-size'> 下記図のように、X方向＝３ Y方向＝2 にした場合、6個の基板が面付けされて制作されます。
                    </p>
                    <p className='all-content-font-size'> デフォルトで5mmの捨て基板が追加されます。
                    </p>
                    <p className='all-content-font-size'> ※単品形状での基板サイズが20mm×20mm以下の場合、Vカットによる面付けができません。
                    </p>
                    <p className='all-content-font-size'> ※複雑な基板形状の場合、お客様にてシート形状にしたガーバーファイルを作成のうえご注文下さい。
                    </p>
                     <div className="brElement"></div>
                    {/*<p className='all-content-font-size'> &nbsp;&nbsp;&nbsp;&nbsp;*/}
                        {/*<text className="red-faq-txt"> 下記画像はサイト完成後、差し替え必要</text>*/}
                    {/*</p>*/}

                    <img src={faq5} className=" faq-full-img"/>
                     <div className="brElement"></div>
                     <div className="brElement"></div>
                    <h4 id="n"><b>
                        メタルマスクの注文方法を教えて下さい。
                    </b>
                    </h4>
                    <p className='all-content-font-size'> 部品実装を行う場合、メタルマスクを使用すると効率よく実装を行うことができます。
                    </p>
                    <p className='all-content-font-size'> 見積画面にて「フレーム有り」「フレーム無し」を選択することが出来ます。
                    </p>
                    <p className='all-content-font-size'> フレーム無しの場合、軽量のため運送コストを削減できます。
                    </p>
                    <div>
                        <div className='col-md-6'>
                            <img src={faq6} className="img-div"/>
                             <div className="brElement"></div>  <div className="brElement"></div><p className="move-text">フレーム有り</p>
                        </div>
                        <div className='col-md-6'>
                            <img src={faq7} className="img-div"/>
                             <div className="brElement"></div> <div className="brElement"></div> <p className="move-text">フレーム無し</p>
                        </div>


                    </div>

                     <div className="brElement"></div>

                    <p className='all-content-font-size'>
                        メタルマスクはプリント基板と一緒にご注文することができます。
                    </p>
                    <p className='all-content-font-size'> ガーバーファイルをアップロードしてプリント基板入力後
                    </p>
                    <p className='all-content-font-size'> ”SMTメタルマスク：SMTメタルマスクを一緒に注文する“に☑を入れて下さい。
                    </p>

                    <img src={faq8} className=" faq-full-img"/>

                    <div className='col-md-10'></div>
                    <div className='col-md-2 col-12-custom'>
                        <Link to="/yourorderTopic">
                            <span className='font-size-20'>
                            戻る
                            </span>
                        </Link>
                    </div>

                    <div>
                        <Modal dialogClassName="contact-modal" show={this.state.show} onHide={this.handleClose}>
                            <Modal.Header closeButton>
                                <div className="title-1 color-text">
                                    <FormattedMessage id="app.navigation.contact"
                                                      defaultMessage="Contact"
                                                      description=""/>
                                </div>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="contact-form-text">
                                    <UserInquiryForm userId={InitialQuotationState.loggedUserId}
                                                     handle={this.handleClose}/>
                                </div>

                            </Modal.Body>

                        </Modal>
                    </div>
                </div>
            </div>
        );
    }
}

export default YourOrder;




// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/FaqPages/YourOrder.js